module.exports = __webpack_public_path__ + "media/assets/icons/close-cdb4a3364708bfbce2d1ebd7fdc3219e.svg";